import type { ReactElement } from "react";
import { useParams } from "@tanstack/react-router";

import { Privacy } from "./legal/Privacy";
import { Terms } from "./legal/Terms";

/** `/legal/$doc` — anything that isn't `privacy` renders the Terms. */
export function Legal(): ReactElement {
  const { doc } = useParams({ from: "/legal/$doc" });
  return doc === "privacy" ? <Privacy /> : <Terms />;
}
